import React, { memo } from 'react';
import { NavMenu } from './NavMenu';
import { Container, Typography, Paper, Box, Grid  } from '@mui/material';
import SignInSignOutButton from "./SignInSignOutButton";


const HomeScreenHeader = (props) => {

    return (
        <NavMenu>
            <span>v{process.env.REACT_APP_VERSION}</span>
            <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>
                {props.title}
            </Typography>
            <SignInSignOutButton />
        </NavMenu>
    );
};

const GreetingLabel = memo(props => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            >
            <Paper elevation={0} square>
                <Typography style={{textAlign: 'center', padding: 15}} variant='h5' component="div">
                    You are not authorized to use this application
                </Typography>
            </Paper>
        </Box>
    );
});

const HomeGrid = (props) => {

    return (
        <div style={{ flexGrow: 1, height: '90vh' }}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                >
                    <GreetingLabel />
            </Grid>
        </div>
    );
};


const UnauthenticatedHomeScreen = () => {

    return (
        <div className="HomeScreen">
            <HomeScreenHeader title="Container Delivery Application" />
            <Container maxWidth={false}>
                <HomeGrid />
            </Container>
        </div>
    );
};

export default UnauthenticatedHomeScreen;